const cav4_exports = {
    "url": "https://loginseguro.petrobras.com.br/fwca/AuthenticationHandler.svlt?ssoEnabled=false&regionalId=RIO&environmentId=DSV&applicationCatalogId=JS86&successfulUrl={{successfulUrl}}&integratedAuthenticationEnabled=false",
};

export default cav4_exports;
